import { Link } from "react-router-dom";

export const IncidenciaButton = ({ testId = "incidencia-btn", dark = false, label = "Notificar Incidencia Web (Sin App)", variant = "pill", large = false }) => {
  const cls =
    variant === "link"
      ? "text-sm font-medium text-slate-500 hover:text-slate-900 transition-colors duration-300"
      : variant === "hero"
        ? "text-sm font-semibold text-amber-700 hover:text-amber-600 underline underline-offset-4 decoration-amber-600/40 transition-colors duration-300"
        : `inline-flex items-center justify-center gap-1.5 font-semibold rounded-full transition-all duration-300 hover:-translate-y-0.5 ${
            large ? "text-base px-9 py-4" : "text-sm px-5 py-2.5"
          } ${
            dark
              ? "text-white border border-white/25 hover:bg-white hover:text-slate-900"
              : "bg-amber-500 text-slate-900 hover:bg-amber-600 shadow-sm"
          }`;

  return (
    <Link to="/notificar-incidencia" data-testid={testId} className={cls}>
      {label}
    </Link>
  );
};
